import { makeStyles } from "@material-ui/core"
import { colors } from "@/styles/colors"
import ColorUtil from "@/utils/ColorUtil"

const useStyles = makeStyles(theme => ({
	searchInputContainer: {
		...ColorUtil.getBackgroundAndContrastColor(colors.gray[50]),
		padding: theme.spacing(2)
	},
	searchInput: {
		...ColorUtil.getBackgroundAndContrastColor(colors.gray[0]),
		height: 40,
		borderRadius: "3px",
		"& svg": {
			marginLeft: theme.spacing(1)
		},
		"&::before": {
			borderBottom: "none"
		}
	},
	listContainer: {
		...ColorUtil.getBackgroundAndContrastColor(colors.gray[50]),
		overflowY: "scroll",
		height: "100%",
		maxHeight: "calc(100vh - 128px)",
		paddingTop: 0
	},
	listItemClickable: {
		"& > *": {
			cursor: "pointer"
		}
	},
	listItem: {
		paddingBottom: theme.spacing(2),
		outline: "none"
	},
	templateStatusChip: {
		cursor: "pointer",
		height: 20
	},
	shortcutNameText: {
		display: "block",
		color: colors.gray[700],
		fontWeight: "bold",
		overflow: "hidden",
		whiteSpace: "nowrap",
		textOverflow: "ellipsis"
	},
	unfocusedMessageItem: {
		...ColorUtil.getBackgroundAndContrastColor(`${colors.gray[0]}) !important`)
	},
	listItemTooltipWrapper: {
		display: "block",
		width: "100%"
	},
	disabledListItemTooltipWrapper: {
		display: "block",
		width: "100%",
		pointerEvents: "auto"
	},
	messageItemPreview: {
		position: "relative",
		width: "100%"
	}
}))

export default useStyles
